import MembershipController from '@club/customer/api/MembershipController'
import useRequestEffect from '@hooks/useRequestEffect'
import useAuth from '@hooks/useAuth'
import React from 'react'
import Table from '@components/modules/Table'
import MainContainer from '@blocks/MainContainer'
import columns from './config/columns'
import useStatic from '@hooks/useStatic'
import Breadcrumps from '@blocks/Breadcrumps'
import { route } from '@helpers'
import useTitle from '@hooks/useTitle'
import useMainTemplate from '@templates/Main/hooks/useMainTemplate'
import usePromosTableOptions from './hooks/usePromosTableOptions'
import ClubPromoController from '@club/customer/api/ClubPromoController'

export default function PromosPage() {
    useTitle("Group: Discounts")
    useMainTemplate({ category: "club" })

    const auth = useAuth<Resources.ClubOwner>()
    const [promos, setPromos] = useRequestEffect(() => ClubPromoController.index(auth.user.club.id))

    const heading = useStatic(<Breadcrumps items={[
        { name: auth.user.club.name, url: route("club:customer") }, 
        { name: "Discounts" }
    ]} />)

    const options = usePromosTableOptions()

    return (
        <MainContainer heading={heading}>
            <Table data={promos} columns={columns} options={options} />
        </MainContainer>
    )
}